var _a;
import { createStrictContext } from '../utils';
export var AppProvider = (_a = createStrictContext(), _a[0]), useApp = _a[1];
